import SessionEventProto from "../session-event-proto";
import OfficesCollection from "../../model2/office/collection";

module.exports = class SessionEvent_OfficesReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        gd.session.offices = OfficesCollection.initFromJson(this.data);
    }
};
